// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"7ee0e7d1","501":"215431e6"}[chunkId] + ".chunk.js";
};